import { createElement } from 'react';
import { Navigate } from 'react-router-dom';

import { newsRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const newsRoute: RouteObject[] = [
  {
    path: newsRoutePaths.news.path,
    async lazy() {
      const NewsPage = await import('@/pages/news/News');
      return { Component: NewsPage.default };
    },
  },
  // 🔴 N-3 — 죽은 파라미터 라우트를 /news(목록)로 리다이렉트한다(designer 제안, 2026-09-03
  // 팀장 승인 — 근거 전문은 ./paths.ts의 newsWithSegment 주석 참고). 문서화 단독보다 나은
  // 이유: 지금 이 라우트가 /news와 완전히 같은 화면을 서빙해 크롤러에게 중복 콘텐츠로
  // 보이는데, 주석은 그 중복을 못 없앤다 — 리다이렉트가 없앤다. 신규 패턴이 아니다 —
  // polymarket/routes.ts의 /polymarket/me → /polymarket/my와 같은 모양을 그대로 복제했다.
  {
    path: newsRoutePaths.newsWithSegment.path,
    element: createElement(Navigate, { to: newsRoutePaths.news.fullPath, replace: true }),
  },
];
